import { Container as ContainerPrimitive } from '@radix-ui/themes'
import { withProps } from '../component-utils.jsx'
import styles from './container.module.css'

export { Container }

const Container = withProps(ContainerPrimitive, {
  className: styles.root,
})
